/* ICM mobile nav drawer — 2026-09-12
 *
 * Replaces the theme's accordion behaviour, which bound the expand action to the
 * 40x40 "+" glyph only (theme.js: `#MobileNav .ad`), leaving the other ~85% of a
 * 270px row as a link that navigated away. Dale, 12-09: "the burger menu sucks …
 * just get rid of the double click … make it work well eg like [directkia]".
 *
 * Behaviour, taken from directkia's own header:
 *   - the WHOLE row toggles; no glyph to hit
 *   - one section open at a time, so the list never runs off the bottom
 *   - children stagger in on --stagger-beat, the reveal keyframe from
 *     directkia/src/index.css, and collapse to nothing under reduced motion
 *   - a parent that has its own destination keeps it as an "All …" first row
 *     (Porsche's escape hatch) — nothing that was reachable becomes unreachable
 *
 * Adds no navigation. Every href here already existed in the menu.
 */
(function () {
  'use strict';

  function rows(el, sel) {
    return Array.prototype.filter.call(el.children, function (c) {
      return c.matches(sel);
    });
  }

  function collapse(li) {
    if (!li.classList.contains('is-open')) return;
    li.classList.remove('is-open');
    var a = rows(li, 'a')[0];
    if (a) a.setAttribute('aria-expanded', 'false');
  }

  function toggle(li, sub, a) {
    var willOpen = !li.classList.contains('is-open');

    // one at a time among siblings — keeps the drawer short
    rows(li.parentElement, 'li').forEach(function (sib) {
      if (sib !== li) collapse(sib);
    });

    li.classList.toggle('is-open', willOpen);
    a.setAttribute('aria-expanded', String(willOpen));

    if (willOpen) {
      rows(sub, 'li').forEach(function (kid, i) {
        kid.style.setProperty('--i', i);
      });
    } else {
      // closing a parent closes anything open beneath it
      Array.prototype.forEach.call(sub.querySelectorAll('li.is-open'), collapse);
    }
  }

  function init() {
    var nav = document.getElementById('MobileNav');
    if (!nav || nav.dataset.icmDrawer) return;
    nav.dataset.icmDrawer = '1';

    // 1. release the theme's glyph-only handler
    if (window.jQuery) {
      try { window.jQuery('#MobileNav .ad').off('click'); } catch (e) {}
    }

    // 2. Drop Login / Register / Wishlist. Dale, 12-09: "lets take login
    //    register and whishlist OFF the burger menu they are pointless on there"
    //    — the header already carries account and wishlist icons.
    //    navigation.liquid emits a literal `<li></li><li></li>` immediately
    //    before them (the template's own separator), so everything from that
    //    marker to the end of the list is the account group.
    var top = rows(nav, 'li');
    var cut = -1;
    for (var n = 0; n < top.length; n++) {
      if (!top[n].textContent.trim() && !top[n].querySelector('img')) { cut = n; break; }
    }
    if (cut > -1) top.slice(cut).forEach(function (li) { li.remove(); });
    // any other blank row the section rendered for a disabled block
    rows(nav, 'li').forEach(function (li) {
      if (!li.textContent.trim() && !li.querySelector('img')) li.remove();
    });

    // 3. wire every row
    Array.prototype.forEach.call(nav.querySelectorAll('li'), function (li) {
      var a = rows(li, 'a')[0];
      var sub = rows(li, 'ul')[0];
      if (!a) return;

      if (!sub) { li.classList.add('icm-leaf'); return; }
      li.classList.add('icm-parent');

      // keep the parent's own page reachable
      var href = a.getAttribute('href');
      if (href && href !== '#' && href !== '' && !sub.querySelector('.icm-all')) {
        var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
        var first = document.createElement('li');
        first.className = 'icm-all-li';
        var link = document.createElement('a');
        link.className = 'icm-all';
        link.setAttribute('href', href);
        link.textContent = 'All ' + label;
        first.appendChild(link);
        sub.insertBefore(first, sub.firstChild);
      }

      // swap the +/- glyph for a chevron the CSS rotates
      var glyph = a.querySelector('i.ad');
      if (glyph) glyph.parentNode.removeChild(glyph);
      var chev = document.createElement('span');
      chev.className = 'icm-chev';
      chev.setAttribute('aria-hidden', 'true');
      a.appendChild(chev);

      a.setAttribute('role', 'button');
      a.setAttribute('aria-expanded', 'false');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(li, sub, a);
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(li, sub, a);
        }
      });
    });

    // 2b. Section divider — the Bar & Shield marks where the general catalogue
    //     ends and the Harley-Davidson section begins. Dale, 12-09: "then a
    //     harley bar & shield image to indicate a new section and then we have
    //     the 2 harley ones".
    //     Anchored on the first top-level row whose label contains
    //     "Harley-Davidson" rather than on a fixed position, so reordering the
    //     blocks in the theme editor cannot strand it. Safe across locales:
    //     brand names are never translated (GLOSSARY.md).
    var first = rows(nav, 'li').filter(function (li) {
      var a = rows(li, 'a')[0];
      return a && /harley-davidson/i.test(a.textContent || '');
    })[0];
    if (first && !nav.querySelector('.icm-sec')) {
      var sec = document.createElement('li');
      sec.className = 'icm-sec';
      sec.setAttribute('aria-hidden', 'true');   // decorative; the labels carry the meaning
      var img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/0468/2724/1627/files/icm-nav-harley-bar-shield.png';
      img.alt = '';
      img.width = 500; img.height = 390;         // intrinsic, so the row reserves its space
      img.loading = 'lazy'; img.decoding = 'async';
      sec.appendChild(img);
      first.parentNode.insertBefore(sec, first);
    }

    nav.classList.add('icm-drawer-ready');

    // 4. stagger the top level each time the drawer opens.
    //    The theme toggles `.active` on the wrapper; nothing animated the panel's
    //    CONTENTS, so the first open arrived fully formed while every subsequent
    //    expand animated. Watch the class and replay the cascade.
    var wrap = nav.closest ? nav.closest('.mobile-nav-wrapper') : null;
    if (wrap && window.MutationObserver) {
      var index = function () {
        var i = 0;
        rows(nav, 'li').forEach(function (li) { li.style.setProperty('--i', i++); });
      };
      var was = wrap.classList.contains('active');
      new MutationObserver(function () {
        var now = wrap.classList.contains('active');
        if (now === was) return;
        was = now;
        if (!now) {
          wrap.classList.remove('icm-opening');
          Array.prototype.forEach.call(nav.querySelectorAll('li.is-open'), collapse);
          return;
        }
        index();
        wrap.classList.remove('icm-opening');
        void wrap.offsetWidth;              // restart the animation
        wrap.classList.add('icm-opening');
      }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // theme.js binds inside jQuery's ready queue; this file is parsed after it, so
  // a ready callback registered here runs after theme.js's and can safely unbind.
  if (window.jQuery) window.jQuery(init);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
